// 261030 — logic THUẦN (không import antd) cho «bấm ảnh để xem lớn» + hình dạng khung ảnh ở luồng 4 bước.

/** Thuộc tính đánh dấu một ảnh xem lớn được và nhóm của nó (chuyển trái/phải chỉ trong cùng nhóm). */
export const VIEWER_GROUP_ATTR = 'data-viewer-group';

export interface ViewerEntry { src?: string | null; alt?: string | null }
export interface ViewerItem { src: string; alt: string }

/**
 * Dựng danh sách xem lớn từ các ảnh cùng nhóm theo thứ tự trên màn. Ảnh không có `src` bị bỏ; vị trí hiện tại tính lại theo danh sách đã lọc.
 * `clickedIndex` ngoài khoảng / trỏ vào ảnh bị bỏ ⇒ null (không mở, tránh mở nhầm ảnh khác).
 */
export function buildGallery(entries: ReadonlyArray<ViewerEntry>, clickedIndex: number): { items: ViewerItem[]; current: number } | null {
  const items: ViewerItem[] = [];
  let current = -1;
  entries.forEach((e, i) => {
    const src = (e.src ?? '').trim();
    if (!src) return;
    if (i === clickedIndex) current = items.length;
    items.push({ src, alt: e.alt ?? '' });
  });
  return current < 0 ? null : { items, current };
}

/**
 * Hình dạng khung ảnh của thẻ tài sản. Sheet nhân vật / con vật là ảnh NGANG DÀI 21:9 (đầu · toàn thân + thước · ô chi tiết) ⇒ khung 21:9 để thấy đủ ba vùng;
 * bối cảnh 16:9; còn lại vuông. Mọi khung đều `object-fit: contain` nên ảnh lệch tỉ lệ vẫn không bị cắt.
 */
export type ThumbShape = 'sheet' | 'wide' | 'square';
export function thumbShapeOf(kind: string | null | undefined, wide?: boolean): ThumbShape {
  if (wide) return 'wide';
  return kind === 'CHARACTER' || kind === 'ANIMAL' ? 'sheet' : 'square';
}
